export type MembershipTab = "plans" | "subscriptions" | "orders" | "tokens" | "events";
export type JsonValue = string | number | boolean | null | JsonValue[] | { [key: string]: JsonValue };
export interface MembershipPage<T> { items: T[]; totalElements: number; page: number; size: number; totalPages: number }
export interface MembershipPlan {
  id: number; planCode: string; displayName: string; maxConnectionCount: number | null;
  productId: string | null; useYn: string; syncStatus: string | null; failureCode: string | null;
  syncedAt: string | null; catalog: JsonValue;
}
export interface MembershipSubscription {
  id: number; userAccountId: number | null; planCode: string; storeType: string;
  productId: string; basePlanId: string | null; offerId: string | null; status: string;
  entitlementActive: boolean; trial: boolean; autoRenew: boolean; environment: string;
  purchasedAt: string | null; expiresAt: string | null; verifiedAt: string | null;
}
export interface MembershipTransaction {
  id: number; userAccountId: number | null; recordType: string; productId: string;
  basePlanId: string | null; offerId: string | null; orderId: string | null;
  verificationStatus: string; subscriptionStatusAtVerification: string | null; orderStatus: string | null;
  environment: string; currency: string | null; paidAmount: string | null; taxAmount: string | null;
  refundAmount: string | null; syncStatus: string | null; failureCode: string | null;
  retryCount: number; acknowledgementStatus: string | null; purchasedAt: string | null;
  orderEventAt: string | null; syncedAt: string | null; nextSyncAt: string | null;
}
export interface MembershipEvent {
  id: number; storeType: string; type: string; status: string; failureCode: string | null;
  retryCount: number; eventAt: string; processedAt: string | null; nextRetryAt: string | null;
}
export interface MembershipDetail { transaction: MembershipTransaction; orderSnapshot: JsonValue }
export type MembershipRow = MembershipPlan | MembershipSubscription | MembershipTransaction | MembershipEvent;
export interface MembershipFilters {
  productId?: string; userAccountId?: string; orderId?: string; status?: string;
  syncStatus?: string; environment?: string; fromDate?: string; toDate?: string;
}
export const membershipTabs: Record<MembershipTab, string> = {
  plans: "상품", subscriptions: "구독", orders: "주문·환불", tokens: "구매 검증", events: "스토어 알림",
};
export const membershipQuery = (tab: MembershipTab, filters: MembershipFilters, page: number) => {
  const query = new URLSearchParams({ page: String(page), size: "50" });
  for (const [key, value] of Object.entries(filters)) if (value?.trim()) query.set(key, value.trim());
  if (tab === "orders" || tab === "tokens") query.set("recordType", tab === "orders" ? "ORDER" : "TOKEN");
  return query.toString();
};
// Keep the server's decimal string; Number conversion loses precision for Money values.
export const membershipMoney = (value: string | null, currency: string | null) =>
  value === null ? "미확인" : currency ? `${value} ${currency}` : `${value} (통화 미확인)`;
